export default __webpack_public_path__ + "static/media/wait.6cf7d21f.png";